class SingleFlightRequest {
  constructor() {
    this.activeRequest = null;
  }

  isBusy = () => Boolean(this.activeRequest);

  start = (key = Symbol('single-flight-request')) => {
    if (this.isBusy()) return null;

    const abortController = new AbortController();
    this.activeRequest = {
      key,
      abortController,
      signal: abortController.signal,
    };
    return this.activeRequest;
  };

  finish = (key) => {
    if (this.activeRequest?.key === key) {
      this.activeRequest = null;
    }
  };

  abort = () => {
    this.activeRequest?.abortController.abort();
    this.activeRequest = null;
  };
}

export default SingleFlightRequest;
